import basement3d from "./plan-1pp-3d.jpg.asset.json";
import main3d from "./plan-1np-3d.jpg.asset.json";
import upper3d from "./plan-2np-3d.jpg.asset.json";
import basement2d from "./plan-1pp-2d.jpg.asset.json";
import main2d from "./plan-1np-2d.jpg.asset.json";
import upper2d from "./plan-2np-2d.jpg.asset.json";

const photoModules = import.meta.glob("./img-*.jpg.asset.json", {
  eager: true,
  import: "default",
}) as Record<string, { url: string }>;

// Photos and the cadastral map retain the order displayed in RE/MAX 450334.
export const sazavaChataImages = Object.entries(photoModules)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([, asset]) => asset.url);

export const sazavaChataFloorPlans = [
  { image: basement3d.url, label: "1. PP – 3D" },
  { image: main3d.url, label: "1. NP – 3D" },
  { image: upper3d.url, label: "2. NP – 3D" },
  { image: basement2d.url, label: "1. PP – 2D" },
  { image: main2d.url, label: "1. NP – 2D" },
  { image: upper2d.url, label: "2. NP – 2D" },
];